"use client";

import { c as _c } from "react/compiler-runtime";
import { IconMagnifyingGlass } from "@central-icons-react/square-outlined-radius-0-stroke-1.5";
import { IconArrowLeftOutline18, IconBoltOutline18 } from "nucleo-ui-outline-18";
import { IntegrationCard } from "@/components/ui/integration-card";
import { PageLayout } from "@/components/ui/page-layout";
import { Button } from "@/components/ui/button";
import type { ServerNodeStatistics } from "@/lib/api/server-fetchers";
import Link from "next/link";
interface Integration {
  type: string;
  name: string;
  description: string;
  integrationType: "trigger" | "action";
  connector?: {
    type: string;
  };
  tags?: string[];
}
interface TagPageClientProps {
  tag: string;
  integrations: Integration[];
  statistics: Record<string, ServerNodeStatistics>;
  connectorLogoMap: Record<string, string>;
}
export default function TagPageClient(t0) {
  const $ = _c(24);
  const {
    tag,
    integrations,
    statistics,
    connectorLogoMap
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      children: <Link href="/integrations" className="text-ds-text-subtle hover:text-ds-text-primary dark:text-ds-text-disabled inline-flex items-center gap-2 text-sm dark:hover:text-white"><IconArrowLeftOutline18 className="h-4 w-4" />Back to Integrations</Link>,
      searchPlaceholder: "Search integrations..."
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = tag.charAt(0).toUpperCase() + tag.slice(1);
  let t3;
  if ($[1] !== t2) {
    t3 = <h1 className="text-ds-text-primary text-3xl font-bold tracking-tight">{t2}</h1>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="rounded-lg bg-blue-100 px-3 py-1 text-sm font-medium text-blue-700 dark:bg-blue-900/30 dark:text-blue-400">Tag</span>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t3) {
    t5 = <div className="mb-2 flex items-center gap-3">{t3}{t4}</div>;
    $[4] = t3;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = integrations.length !== 1 ? "s" : "";
  let t7;
  if ($[6] !== integrations.length || $[7] !== t6 || $[8] !== tag) {
    t7 = <p className="body-sm mt-1">{integrations.length} integration{t6} tagged with "{tag}"</p>;
    $[6] = integrations.length;
    $[7] = t6;
    $[8] = tag;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t5 || $[11] !== t7) {
    t8 = <div>{t5}{t7}</div>;
    $[10] = t5;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Link href="/workflows/edit"><Button asChild={true}><span className="flex items-center gap-2 text-xs"><IconBoltOutline18 className="h-3 w-3" />Workflow</span></Button></Link>;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t8) {
    t10 = <div className="mb-6"><div className="flex items-center justify-between">{t8}{t9}</div></div>;
    $[14] = t8;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== connectorLogoMap || $[17] !== integrations || $[18] !== statistics || $[19] !== tag) {
    t11 = integrations.length > 0 ? <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">{integrations.map(integration => <IntegrationCard key={`${integration.integrationType}-${integration.type}`} integration={integration} statistics={statistics?.[integration.type]} statsLoading={false} highlightedTag={tag} showMetadata={true} connectorLogoUrl={integration.connector?.type ? connectorLogoMap[integration.connector.type] : undefined} />)}</div> : <div className="flex flex-col items-center justify-center py-16 text-center"><div className="mb-4"><div className="bg-ds-neutral-100 dark:bg-ds-neutral-800 mb-4 flex h-16 w-16 items-center justify-center rounded-full"><IconMagnifyingGlass className="text-ds-text-disabled dark:text-ds-text-subtle h-8 w-8" /></div></div><h3 className="text-ds-text-primary mb-2 text-lg font-semibold">No integrations with tag "{tag}"</h3><p className="body-sm mb-6">This tag doesn't have any integrations yet.</p><Link href="/integrations"><Button><span className="text-xs">Browse All Integrations</span></Button></Link></div>;
    $[16] = connectorLogoMap;
    $[17] = integrations;
    $[18] = statistics;
    $[19] = tag;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t10 || $[22] !== t11) {
    t12 = <PageLayout header={t1}>{t10}{t11}</PageLayout>;
    $[21] = t10;
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  return t12;
}